const Request = require('./BaseRequest')
const TrackerGraph = require('../graph/TrackerGraph')

module.exports = class TrackerRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new TrackerGraph(this.apiDomain)
    }
  
    //Learn & Earn tracker
    async setArticlePoint(content_id, contact_id, earned_point)
    { 
        let args = {content_id: content_id, contact_id: contact_id, earned_point: earned_point}
        let { type, query } = this.graph.setArticlePoints(['id'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    //Learn & Earn Video tracker
    async setVideoPoint(content_id, contact_id, earned_point, time_watched)
    { 
        let args = {content_id: content_id, contact_id: contact_id, earned_point: earned_point, time_watched: time_watched}
        let { type, query } = this.graph.setVideoPoints(['id'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }

    //Learn & Earn Video tracker
    async updateVideoPointStatus(content_id, contact_id)
    { 
        let args = {content_id: content_id, contact_id: contact_id}
        let { type, query } = this.graph.updateVideoStatus(['id'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }


    //Learn & Earn Set User badge
    async setBadge(contact_id)
    { 
        let args = {contact_id: contact_id}
        let { type, query } = this.graph.setUserBadge(['id'], args)
        let data = await this.graph.request(query, args, type)
        return data
    }


    swrUserBadges(contactId)
    {
        let args = {contact_id: contactId}

        let { type, query } = this.graph.getUserBadgeQuery([
            'id', 'user_id', 'contact_id', 'status', 'created', 'updated',
            { badge: [ 
                'id', 'name', 'image', 'description', 'point', 'duration'
            ]}
        ], args)

        return this.graph.swrRequest(query, this.swrOptions, type)
    }
}